import { Link, useLocation } from "react-router-dom";
import { news } from "@/mocks/news";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center">
      <div className="relative">
        <span className="pointer-events-none select-none font-heading text-[7rem] font-black leading-none text-background-200 md:text-[10rem]">
          404
        </span>
      </div>
      <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的地址 <span className="text-primary-400">{location.pathname}</span> 不存在或已被移除。
        不如看看下面的热门内容？
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line"></i>返回首页
        </Link>
        <Link
          to="/videos"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-400"
        >
          <i className="ri-play-circle-line"></i>去看视频
        </Link>
      </div>

      <div className="mt-12 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
        {news.slice(0, 3).map((n) => (
          <Link
            key={n.id}
            to={`/news/${n.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 text-left transition-colors hover:border-primary-400/60"
          >
            <div className="h-32 w-full overflow-hidden">
              <img
                src={n.cover}
                alt={`${n.title} - 热门内容`}
                title={`${n.title} - 91.con`}
                className="h-full w-full object-cover transition-transform group-hover:scale-105"
              />
            </div>
            <h2 className="line-clamp-2 p-3 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-400">
              {n.title}
            </h2>
          </Link>
        ))}
      </div>
    </div>
  );
}